import { useEffect, useState } from 'react';

/**
 * El valor recién cuando deja de cambiar por {@code delayMs}: para un buscador que consulta al backend, así se pide una
 * vez al terminar de escribir y no con cada tecla.
 */
export default function useDebouncedValue<T>(value: T, delayMs: number): T {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delayMs);
        return () => clearTimeout(timer);
    }, [value, delayMs]);

    return debounced;
}
